import axiosInstance from './axiosInstance';
import BASE_URL from '../config/apiConfig';
import ORCH_BASE_URL from '../config/orchConfig';
import orchestratorAxios from './orchestratorAxios';

const API_URL = `${BASE_URL}/workflows`;

const ORCH_API_URL = `${ORCH_BASE_URL}`;

export const fetchWorkflowRunHistory = async (params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/workflow-run-history`, {
    params,
  });
  console.log('response of dashboard run history:', response);
  return response.data;
};

export const fetchWorkflowMetricsSummary = async () => {
  const response = await axiosInstance.get(
    `${API_URL}/reports/metrics/summary`
  );
  console.log('response of metrics summary of dashboard:', response);
  return response.data;
};

export const fetchWorkflowStepsSummary = async (params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/reports/steps/summary`, {
    params,
  });
  console.log('response of steps summary of dashboard:', response);
  return response.data;
};

export const fetchFlowExecutionHistory = async (params = {}) => {
  const { limit = 1000 } = params; // Default to 1000 to get more accurate count
  const response = await orchestratorAxios.get(
    `${ORCH_API_URL}/workflows/summary?limit=${limit}`
  );
  return response.data;
};

export const fetchWorkflowRunsById = async (workflowId) => {
  const response = await orchestratorAxios.get(
    `${ORCH_API_URL}/workflows/${workflowId}/runs?limit=20`
  );
  return response.data;
};
